import { IconButton } from '@nexelem/components';
import {
  PlanViewToggle,
  GanttModeToggle,
  TasksOrBrigadeButton,
  toggleProductionPlanSettingsDrawer,
  CreateSimulationButton,
  KanbanFilterButton,
  GanttFilterButton,
  ResetButton,
  GanttFilterDate,
  SyncButton,
  KanbanFilterDate,
  toggleGanttLegendDrawer,
  SimulationListButton,
} from './components';
import { useCustomTranslation } from '../../../hooks';
import { PERMS } from '../../../routes/permissions';
import { PlanView, useLoadQueues, useProductionPlanQueryParams } from './hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { SearchButton } from './searchComponents';
import { SimulationInProgressBanner } from './GanttSimulation/components';
import { Header } from '@nexelem/header';
import { ProductionPlanFooter } from './ProductionPlanFooter';
import { ProductionPlans } from './ProductionPlans';
import { useAuthContext } from '../../../providers/AuthProvider';
import { ClientId, useConfig } from '@nexelem/config';

export const ProductionPlan = () => {
  const { hasPermission } = useAuthContext();
  const { clientId } = useConfig();
  const canViewAssignmentMode = hasPermission(PERMS.PERM_3);
  const canViewSimulationList = hasPermission(PERMS.PERM_11);
  const canEditSimulation = hasPermission(PERMS.PERM_12);
  const canViewKanbanBoard = hasPermission(PERMS.PDB_6);
  const { tWrapper } = useCustomTranslation('products.productionPlan');

  const {
    queryParams: { view },
  } = useProductionPlanQueryParams();

  useLoadQueues();

  const isKanban = canViewKanbanBoard && view === PlanView.KANBAN;
  const isGantt = view === PlanView.GANTT;

  return (
    <div className="flex h-full flex-col">
      <div className="px-8">
        <Header
          title={
            <div className="flex items-center gap-4">
              <div>{tWrapper('header')}</div>
              {isGantt && <GanttFilterDate />}
              {isKanban && <KanbanFilterDate />}
              <SimulationInProgressBanner />
            </div>
          }
        >
          <SyncButton />
          {clientId === ClientId.sanok ? (
            canEditSimulation && <CreateSimulationButton />
          ) : canViewSimulationList ? (
            <SimulationListButton />
          ) : (
            canEditSimulation && <CreateSimulationButton />
          )}
        </Header>
        <div className="mt-2 mb-2 flex gap-4">
          <TasksOrBrigadeButton />
          <PlanViewToggle />
          {isGantt && canViewAssignmentMode && <GanttModeToggle />}
          <div className="flex gap-2">
            <SearchButton />
            {isKanban ? <KanbanFilterButton /> : <GanttFilterButton />}
            <IconButton
              Icon={<FontAwesomeIcon icon={faGear} />}
              size="small"
              onClick={toggleProductionPlanSettingsDrawer}
            />
            <IconButton
              Icon={<FontAwesomeIcon icon={faCircleInfo} />}
              size="small"
              onClick={() => toggleGanttLegendDrawer({ isSimulation: false })}
            />
          </div>
          <ResetButton />
        </div>
      </div>
      <div className="grow overflow-hidden">{(isGantt || isKanban) && <ProductionPlans view={view} />}</div>
      {/* Footer */}
      <ProductionPlanFooter />
    </div>
  );
};
